"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collectedOptions_1 = require("../config/collectedOptions");
var store_1 = require("../store/store");
var mobx_1 = require("mobx");
var currentCategory = mobx_1.computed(function () {
    for (var categoryIndex = 0; categoryIndex < collectedOptions_1.default().length; categoryIndex++) {
        var currentCategory_1 = collectedOptions_1.default()[categoryIndex];
        if (currentCategory_1.key == store_1.getStore().currentCategoryKey) {
            return currentCategory_1;
        }
    }
    return null;
});
exports.default = function () { return currentCategory.get(); };
//# sourceMappingURL=getCurrentCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/selectors/getCurrentCategory.js
// module id = 3770
// module chunks = 2